import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule } from '@angular/forms';
import { AppSuiteRfbModule } from '../app-suite-rfb.module';
import { ConsultaAtoComponent } from './components/consulta-ato/consulta-ato.component';
import { ConsultaRoutingModule } from './consulta-routing.module';
import { AtosModule } from '../atos/atos.module';

@NgModule({
    declarations: [
        ConsultaAtoComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        AppSuiteRfbModule,
        ConsultaRoutingModule,
        AtosModule
    ]
})
export class ConsultaModule { }
